import {
  useGetAllCatalogProductGridItemsQuery as useGetCatalogProductsQuery,
  useGetAllCatalogProductGridItemsLazyQuery as useGetCatalogProductsLazyQuery,
  GetAllCatalogProductGridItemsQuery
} from '@graphql/generated';
import { useMemo } from 'react';
import { CatalogProductTileItem } from '../../../Catalog.types';

const extractCatalogItems = (fallbackCatalogData: GetAllCatalogProductGridItemsQuery | undefined) => {
  const results: CatalogProductTileItem[] = [];
  fallbackCatalogData?.productCatalogSearchResults?.pagedResults?.edges?.forEach(x => {
    if (x.node.catalogItem) {
      results.push(x.node.catalogItem);
    }
  });
  return results;
};

type UseGetCatalogProductGridItemsQueryArgs = {
  options: Parameters<typeof useGetCatalogProductsQuery>[0];
};

export const useGetCatalogProductGridItemsQuery = (args: UseGetCatalogProductGridItemsQueryArgs) => {
  const { options } = args;
  const { data, ...restQueryReturn } = useGetCatalogProductsQuery(options);

  const productList = useMemo(() => {
    return extractCatalogItems(data);
  }, [data]);

  return {
    data,
    productList,
    ...restQueryReturn
  } as const;
};

type UseGetCatalogProductGridItemsLazyQueryArgs = {
  options: Parameters<typeof useGetCatalogProductsLazyQuery>[0];
};
export const useGetCatalogProductGridItemsLazyQuery = (args: UseGetCatalogProductGridItemsLazyQueryArgs) => {
  const { options } = args;
  const [sendRequest, { data, ...restQueryReturn }] = useGetCatalogProductsLazyQuery(options);

  const fallbackCatalogProductList = useMemo(() => {
    return extractCatalogItems(data);
  }, [data]);

  return {
    sendRequest,
    data,
    fallbackCatalogProductList,
    ...restQueryReturn
  } as const;
};
